import { useEffect, useState } from "react";
import { api } from "../api.js";

const TEAM = [
  { initials: "DS", name: "David Schmidt", role: "Admin" },
  { initials: "RS", name: "Robert Schmidt", role: "Laser" },
  { initials: "AS", name: "Anna Schmidt", role: "Drucker" },
];

export default function TeamScreen() {
  const [tasks, setTasks] = useState([]);
  const [assignee, setAssignee] = useState("David Schmidt");
  const [title, setTitle] = useState("");
  const [note, setNote] = useState("");

  const load = () => api.list("tasks").then(setTasks).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!title) return;
    await api.createItem("tasks", { assignee, title, note });
    setTitle(""); setNote("");
    load();
  };

  const toggleDone = (t) => api.updateItem("tasks", t.id, { done: !t.done }).then(load);

  return (
    <div>
      <div className="dx-team-row">
        {TEAM.map((t) => (
          <div key={t.initials} className="dx-card dx-team-member">
            <div className="dx-avatar">{t.initials}</div>
            <div>
              <strong>{t.name}</strong>
              <div className="dx-muted">{t.role}</div>
            </div>
          </div>
        ))}
      </div>

      <h3 style={{ marginTop: "24px" }}>Aufgaben</h3>
      <form className="dx-inline-form" onSubmit={add}>
        <select className="dx-input" value={assignee} onChange={(e) => setAssignee(e.target.value)}>
          {TEAM.map((t) => <option key={t.name} value={t.name}>{t.name}</option>)}
        </select>
        <input className="dx-input" placeholder="Aufgabe" value={title} onChange={(e) => setTitle(e.target.value)} />
        <input className="dx-input" placeholder="Notiz" value={note} onChange={(e) => setNote(e.target.value)} />
        <button className="dx-btn dx-btn--primary" type="submit">Hinzufügen</button>
      </form>

      <div className="dx-list" style={{ marginTop: "16px" }}>
        {tasks.map((t) => (
          <label key={t.id} className="dx-task-row">
            <input type="checkbox" checked={t.done} onChange={() => toggleDone(t)} />
            <span style={{ textDecoration: t.done ? "line-through" : "none" }}>
              <strong>{t.assignee}:</strong> {t.title} {t.note ? `– ${t.note}` : ""}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
